import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=ad4f5ce6&scoped=true"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"
import style0 from "./Design.vue?vue&type=style&index=0&id=ad4f5ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f5ce6",
  null
  
)

export default component.exports